import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../redux/features/cartSlice";
import {
  addToWishlist,
  removeFromWishlist,
} from "../redux/features/wishlistSlice";
import {
  getPercentage,
  getToken,
  percentage,
  isProductInWishList,
} from "../resources/helper/helper";
import { toast } from "react-toastify";
import { compareProduct } from "../redux/features/productSlice";
import { CircularProgress } from "@mui/material";

const ProductCard = ({
  name,
  category,
  productId,
  description,
  price,
  discount_price,
  featured_media,
  ratings,
  stock,
  media,
  product,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdded = isProductInWishList(product?._id);
  const { compareLoading } = useSelector((state) => state.product);
  const token = getToken();

  const handleDetailsNavigation = () => {
    navigate("/productDetails", { state: product });
  };

  const handleCart = () => {
    dispatch(addToCart({ ...product, quantity: 1 }));
    toast.success("Added successfully!", {
      position: "top-center",
      theme: "colored",
    });
  };
  const handleWishlist = () => {
    if (!isProductInWishList(product?._id)) {
      dispatch(addToWishlist({ ...product }));
      toast.success("Product Added to your wishlist!", {
        position: "top-center",
        theme: "colored",
      });
    } else {
      dispatch(removeFromWishlist(product?._id));
      toast.error("Product Removed from wishlist!", {
        position: "top-center",
        theme: "colored",
      });
    }
  };

  const handleCompare = () => {
    if (token) {
      const payload = {
        token,
        productId,
      };
      dispatch(compareProduct(payload))
        .unwrap()
        .then((res) => {
          console.log("Handle Compare Response", res?.comparisonAnalysis);
          if (res?.comparisonAnalysis?.length > 1) {
            navigate("/compare", { state: res?.comparisonAnalysis });
          } else {
            toast.error("There isn't any similar product", {
              position: "top-center",
              theme: "colored",
            });
          }
        })
        .catch((err) => {
          toast.error(err, {
            position: "top-center",
            theme: "colored",
          });
        });
    }
  };

  return (
    <div
      className="col-lg-4 col-md-4 col-sm-12 col-12"
      style={{ display: "flex", alignItems: "stretch", marginBottom: "30px" }}
    >
      <div
        className="product-cart-wrap"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          padding: "10px 2px",
          boxSizing: "border-box",
          flexWrap: "wrap",
        }}
      >
        <div className="product-img-action-wrap" style={{ flexGrow: 1 }}>
          <div
            className="product-img product-img-zoom"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a
              style={{
                width: "200px",
                height: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                className="default-img"
                src={media?.length > 0 ? media[0] : featured_media}
                alt=""
                style={{ width: "80%", height: "auto", objectFit: "contain" }}
              />
              <img
                className="hover-img"
                src={media?.length > 1 ? media[1] : featured_media}
                alt=""
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </a>
          </div>
          <div className="product-action-1" style={{ marginTop: "10px" }}>
            <a
              aria-label={isAdded ? "Removed from Wishlist" : "Add To Wishlist"}
              className="action-btn"
              onClick={handleWishlist}
            >
              <i
                className="fi-rs-heart"
                style={{
                  color: isAdded && "red",
                }}
              />
            </a>
            <a
              aria-label="Compare"
              className="action-btn"
              onClick={handleCompare}
            >
              {compareLoading ? (
                <CircularProgress size={14} color="secondary" />
              ) : (
                <i className="fi-rs-shuffle" />
              )}
            </a>
            <a
              aria-label="Details"
              className="action-btn"
              onClick={handleDetailsNavigation}
            >
              <i className="fi-rs-eye" />
            </a>
          </div>
          {percentage(discount_price, price)?.length > 0 && (
            <div className="product-badges product-badges-position product-badges-mrg">
              <span className="hot">{percentage(discount_price, price)}</span>
            </div>
          )}
        </div>
        <div
          className="product-content-wrap"
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div className="product-category" style={{ marginBottom: "5px" }}>
            <a>{category}</a>
          </div>
          <h2 style={{ marginBottom: "10px", fontSize: "16px" }}>
            <a>{name}</a>
          </h2>
          <div className="product-rate-cover" style={{ marginBottom: "10px" }}>
            <div className="product-rate d-inline-block">
              <div
                className="product-rating"
                style={{
                  width: `${getPercentage(ratings?.averageRating)}%`,
                }}
              />
            </div>
            <span className="font-small ml-5 text-muted">{`(${
              ratings?.averageRating ? ratings?.averageRating : 0
            })`}</span>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <span className="font-small text-muted">
              By <a>{product?.vendor?.businessName}</a>
            </span>
          </div>
          <div
            className="product-card-bottom"
            style={{
              marginTop: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div className="product-price">
              <span>Rs.{discount_price}</span>
              <span className="old-price">Rs.{price}</span>
            </div>
            <div className="add-cart">
              <a className="add" onClick={handleCart}>
                <i className="fi-rs-shopping-cart mr-5" />
                Add
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
